import {useMutation} from '@apollo/react-hooks';

import type {
    setOffice365MailSendIsEnabled as SetOffice365MailSendIsEnabledMutation,
    setOffice365MailSendIsEnabledVariables as SetOffice365MailSendIsEnabledMutationVariables,
} from 'nutshell-graphql-types';

import SET_OFFICE365_MAIL_SEND_IS_ENABLED from '../mutations/set-office365-mail-send-is-enabled.graphql';

export function useSetOffice365MailSendIsEnabled() {
    const [enableO365, {loading}] = useMutation<
        SetOffice365MailSendIsEnabledMutation,
        SetOffice365MailSendIsEnabledMutationVariables
    >(SET_OFFICE365_MAIL_SEND_IS_ENABLED);

    return {
        enableO365,
        isLoading: loading,
    };
}
